module.exports = __webpack_public_path__ + "static/media/covidapp.bb31a742.webp";